/**
 * Wire types for tilt-pos-api responses. Kept in lockstep with the
 * Lambda handler shapes — every field name here matches a key the
 * Python side actually emits, so a typo on either end is a TypeScript
 * compile error or a runtime KeyError that surfaces in tests.
 */
/** Thrown on any non-2xx response. */
export class ApiError extends Error {
    status;
    body;
    constructor(status, body) {
        super(`tilt-pos-api ${status}`);
        this.name = "ApiError";
        this.status = status;
        this.body = body;
    }
}
//# sourceMappingURL=types.js.map